/** 家族共有の自動同期（共有コードを一度つなぐと、以降は定期・起動時・変更時に同期） */

export type FamilySyncRole = 'host' | 'member';

export type FamilySyncPrefs = {
  code: string;
  role: FamilySyncRole;
  autoSync: boolean;
  lastSyncAt?: string;
};

const KEY = 'yorisoi-family-sync-v1';
const LEGACY_CODE_KEY = 'yorisoi-family-share-code';

export function loadFamilySyncPrefs(): FamilySyncPrefs | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<FamilySyncPrefs>;
      if (typeof parsed.code === 'string' && parsed.code.includes('-')) {
        return {
          code: parsed.code.trim().toUpperCase(),
          role: parsed.role === 'member' ? 'member' : 'host',
          autoSync: parsed.autoSync !== false,
          lastSyncAt: typeof parsed.lastSyncAt === 'string' ? parsed.lastSyncAt : undefined,
        };
      }
    }
    const legacy = localStorage.getItem(LEGACY_CODE_KEY);
    if (legacy && legacy.includes('-')) {
      const migrated: FamilySyncPrefs = {
        code: legacy.trim().toUpperCase(),
        role: 'host',
        autoSync: true,
      };
      saveFamilySyncPrefs(migrated);
      return migrated;
    }
  } catch {
    // ignore
  }
  return null;
}

export function saveFamilySyncPrefs(prefs: FamilySyncPrefs): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs));
    localStorage.setItem(LEGACY_CODE_KEY, prefs.code);
  } catch {
    // ignore
  }
}

export function clearFamilySyncPrefs(): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem(LEGACY_CODE_KEY);
  } catch {
    // ignore
  }
}

export function markFamilyLinked(code: string, role: FamilySyncRole): FamilySyncPrefs {
  const prefs: FamilySyncPrefs = {
    code: code.trim().toUpperCase(),
    role,
    autoSync: true,
    lastSyncAt: new Date().toISOString(),
  };
  saveFamilySyncPrefs(prefs);
  return prefs;
}

/** 自動同期の間隔（ミリ秒）— 起動中は約3分ごと */
export const FAMILY_SYNC_INTERVAL_MS = 3 * 60 * 1000;

/** チェック変更後のデバウンス（ミリ秒） */
export const FAMILY_SYNC_DEBOUNCE_MS = 8 * 1000;
